import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';

import { Customer } from "./customer.model";

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private httpClient: HttpClient) { }

  selectedCustomer: Customer;
  selectedCustomerList: Customer[];

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDCustomer(customer: Customer) {

    // console.log(customer);
    // console.log("------Customer");
    // var body = JSON.stringify(customer);
    // console.log(body)
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/Customers/IUD', body, requestOptions).map(x => x.json());

    customer.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    customer.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    customer.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    customer.SaasId = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = customer;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/IUD', body, { headers: headers });
  }

  FetchCustomerByCustomerId(customer) {

    customer.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    customer.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    customer.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    customer.SaasId = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = customer;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/Fetch', body, { headers: headers });
  }

  FetchCustomerList() {

    this.selectedCustomer = new Customer();
    this.selectedCustomer.IsCustomerSearch =false;
    this.selectedCustomer.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedCustomer.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCustomer.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedCustomer.SaasId = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedCustomer;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/FetchList', body, { headers: headers });
  }

  FetchSurveyNoCustomerList(surveyNo : any) {

    this.selectedCustomer = new Customer();
    this.selectedCustomer.SurveyNo  = + surveyNo;
    this.selectedCustomer.IsCustomerSearch =true;
    this.selectedCustomer.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedCustomer.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCustomer.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedCustomer.SaasId = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedCustomer;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/FetchList', body, { headers: headers });
  }

  // ------------Load controls ------------------------------


  FetchReportsCustomerList(rptSearchData: any ){
    this.selectedCustomer= new Customer();
    this.selectedCustomer.ReportName = rptSearchData.ReportName;
    this.selectedCustomer.SchemeId = rptSearchData.SchemeId;
    this.selectedCustomer.LoanTypeId = rptSearchData.LoanTypeId;
    this.selectedCustomer.LoanCategoryId = rptSearchData.LoanCategoryId;
    this.selectedCustomer.BranchId = rptSearchData.BranchId;  
    this.selectedCustomer.CentreId = rptSearchData.CentreId;

    this.selectedCustomer.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedCustomer.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCustomer.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedCustomer.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedCustomer;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/Report', body, { headers: headers });
  }

  IUDCustomerFiles(formData:FormData) {

    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/IUDFiles', formData, 
    {
      reportProgress: true,
      observe: 'events'
    });

  }

}
